/**
 * INFO
 * Taken from https://gist.github.com/Chocksy/e9b2cdd4afc2aadc7989762c4b8b495a
 * @see https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/#decluttering-sentry
 */
/**
 * Will cause a deprecation warning, but the demise of `ignoreErrors` is still under discussion.
 * @see: https://github.com/getsentry/raven-js/issues/73
 */
export var ignoreErrors = [
// Random plugins/extensions
'top.GLOBALS',
// See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', "Can't find variable: ZiteReader", 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose',
// Facebook borked
'fb_xd_fragment',
// ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
// See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
'bmi_SafeAddOnload', 'EBCallBackMessageReceived',
// See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
'conduitPage',
// Generic error code from errors outside the security sandbox
// You can delete this if using raven.js > 1.0, which ignores these automatically.
'Script error.',
// Avast extension error
'_avast_submit'];

/**
 * Allow only those url to report errors.
 */
export var allowUrls = [/https:\/\/assets-admin-gandi\.global\.ssl\.fastly\.net/, /https:\/\/.*\.gandi\.net/];